import React from 'react';
import { formatPercent } from '../../../../../Helpers/Percent';

interface Props {
    value: string;
}

export const Percentage: React.FC<Props> = ({ value }: Props) => <>{formatPercent(value)}</>;
